export default __webpack_public_path__ + "static/media/trevor.fb4563bc.webp";